module.exports = __webpack_public_path__ + "static/media/tutorial-02.bb5c2d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial-02.jpg
// module id = 323
// module chunks = 0